import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  congratulationsTitle: {
    description: 'Title for the congratulations banner on the setup complete step',
    defaultMessage: 'Congratulations, your basic set up complete!',
    id: 'xYIzOd',
  },
  congratulationsSubtitle: {
    description: 'Subtitle for the congratulations banner on the setup complete step',
    defaultMessage: 'You can now view orders and generate labels',
    id: 'fcT0SM',
  },
  stepTitle: {
    description: 'Title for the advanced options step in the FTU wizard',
    defaultMessage: 'Advanced Options',
    id: 'IABgVn',
  },
  stepDescription: {
    description: 'Description for the advanced options step in the FTU wizard',
    defaultMessage: 'Optimize your workflows by unlocking these additional options and features.',
    id: 'HCgOeR',
  },
});
